namespace Areas.Dialogs.EditAccountCIBCost {
    "use strict";

    export function preventTotalRowsEdit(e: any) {
        const keyValue = e.key;

        if (Keys.totalKeys.includes(keyValue) || Keys.analyticalKeys.includes(keyValue)) {
            e.cancel = true;
        }
    }

    export function highlightTotalRows(e: any) {
        const keyValue = e.key;

        if (e.rowType == "data") {
            if (Keys.totalKeys.includes(keyValue)) {
                e.rowElement[0].class = "";
                e.rowElement[0].style.backgroundColor = "#F3FAFF";
                e.rowElement[0].style.fontWeight = "bold";
            } else if (Keys.analyticalKeys.includes(keyValue)) {
                e.rowElement[0].class = "";
                e.rowElement[0].style.backgroundColor = "#FFFFF4";
            }
        }
    }

    export function preventRowSelection(e: any) {
        e.component.deselectRows(e.selectedRowKeys);
    }

    export function formatCell(e: any) {
        const fieldData = e.value;
        let fieldHtml = "";

        if (e.rowType == "data") {
            if (e.column.dataField == "description"
                && (Keys.totalKeys.includes(e.key)) || Keys.analyticalKeys.includes(e.key)) {
                const $cellElement = e.cellElement[0];
                $cellElement.style.paddingLeft = "20px";
            }

            if (e.column.dataField != "description" && Keys.totalKeys.includes(e.key)) {
                let total = DevExpress.localization.formatNumber(fieldData, { type: "$ #,##0" });

                fieldHtml = `<div>${total}</div>`;
                e.cellElement.html(fieldHtml);
            }

            if (e.column.dataField != "description" && e.key == Keys.ASFGSFRatioKey) {
                let percent = DevExpress.localization.formatNumber(fieldData, { type: "##0.00 %" });

                fieldHtml = `<div>${percent}</div>`;
                e.cellElement.html(fieldHtml);
            }

            if (e.column.dataField != "description"
                    && e.key != Keys.ASFGSFRatioKey
                    && Keys.analyticalKeys.includes(e.key)) {
                let persqft = DevExpress.localization.formatNumber(fieldData, { type: "$ #,##0 per sf" });

                fieldHtml = `<div>${persqft}</div>`;
                e.cellElement.html(fieldHtml);
            }
        }
    }

    export function calculateForTotalColumn(data: any) {
        let result = "";

        if (data.key != "Name" && !Keys.analyticalKeys.includes(data.key)) {
            result = data.c1 + data.c2 + data.c3;
        };

        if (Keys.analyticalKeys.includes(data.key)) {
            result = calculateTotalRatios(data.key);
        };

        return result;
    }

    function getTotalForKey(data:any, key:string) {
        return data.filter((x: any) => x.key == key).map((d: any)=> d.c1 + d.c2 + d.c3)[0];
    }

    function calculateTotalRatios(key: string): string {
        let data = getData();
        let result = "";

        const totalCurrentOGSFValue = getTotalForKey(data, Keys.currentOGSFKey);
        const totalProposedASFValue = getTotalForKey(data, Keys.proposedASFKey);
        const totalCurrentASFValue = getTotalForKey(data, Keys.currentASFKey);
        const totalP1Value = getTotalForKey(data, Keys.p1Key);
        const totalP2Value = getTotalForKey(data, Keys.p2Key);
        const totalP3Value = getTotalForKey(data, Keys.p3Key);
        const totalPWCTotalValue = getTotalForKey(data, Keys.pwcTotalKey);
        const format = DevExpress.localization.formatNumber;
        const squareFeetRatioFormat = "$ #,##0 per sf";

        switch (key) {
            case Keys.ASFGSFRatioKey:
                result = format(
                    totalCurrentOGSFValue != 0 ? totalProposedASFValue / totalCurrentOGSFValue  : 0,
                    { type: '##0.00 %' });
                break;

            case Keys.BuildingCostGSFRatioKey:
                result = format(
                    totalCurrentOGSFValue != 0 ? totalP1Value / totalCurrentOGSFValue : 0,
                    { type: squareFeetRatioFormat });
                break;

            case Keys.BuildingCostASFRatioKey:
                result = format(
                    totalCurrentASFValue != 0 ? totalP1Value / totalCurrentASFValue : 0,
                    { type: squareFeetRatioFormat });
                break;

            case Keys.PWCGSFRatioKey:
                result = format(
                    totalCurrentOGSFValue != 0 ? totalPWCTotalValue / totalCurrentOGSFValue : 0,
                    { type: squareFeetRatioFormat });
                break;

            case Keys.PWCASFRatioKey:
                result = format(
                    totalCurrentASFValue != 0 ? totalPWCTotalValue / totalCurrentASFValue : 0,
                    { type: squareFeetRatioFormat });
                break;

            case Keys.P2P3ASFRatioKey:
                result = format(
                    totalCurrentASFValue != 0 ? (totalP2Value + totalP3Value) / totalCurrentASFValue : 0,
                    { type: squareFeetRatioFormat });
                break;
            default:
                break;
        }

        return result;
    }

    function getData() {
        const grid  = $("#EditAccountDIBCostGrid").dxDataGrid("instance");
        let data;

        if (grid.hasEditData()) {
            //if data has been changed we need to get the data
            // from the grid's visible rows method.
            data = grid.getVisibleRows().map((x: any) => x.data);
        } else {
            // otherwise we need the data that was originally
            // assigned to the grid.
            data = grid.getDataSource().items();
        }
        return data;
    }

    export function editCellTemplate(_: any, cellInfo: any) {
        if (cellInfo.data.key == "Name") {
            return createTextBoxEditor(cellInfo);
        } else {
            return createNumberBoxEditor(cellInfo);
        }
    }

    function createTextBoxEditor(cellInfo: any) {
            return $('<div>').dxTextBox({
                value: cellInfo.value,
                onValueChanged(args) {
                    cellInfo.setValue(args.value);
                    enableOKButton();
                }
            });
    }

    function createNumberBoxEditor(cellInfo: any) {
        return $('<div>').dxNumberBox({
            value: cellInfo.value,
            onKeyDown: function (e:any) {
                if (e.event.keyCode === 38 /* down arrow */ || e.event.keyCode === 40 /* up arrow */)
                    e.event.stopPropagation();
            },
            onValueChanged(args) {
                cellInfo.setValue(args.value);
                enableOKButton();

                const grid = cellInfo.component;
                const rowIndex = cellInfo.row.rowIndex;
                const dataField = cellInfo.column.dataField;
                const newValue = args.value;

                calculations.updateCalculations(grid, rowIndex, dataField, newValue);
            }
        });
    }

    function enableOKButton() {
        const okButton = $("#EditAccountCIBCostOkDialog").dxButton("instance");
        if (okButton.option("disabled") === true) {
            okButton.option("disabled", false);
        }
    }

}
